import styled from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9EACB0;
`;

export default Atom({ type: 'label', dataType: 'string', template })